import {SvgIcon} from "@material-ui/core";

export const CustomDiamondIcon = (props) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M5.625 3.125H14.375L18.75 8.125L10 17.5L1.25 8.125L5.625 3.125Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.8352 8.125L9.99997 17.5L6.16473 8.125L9.99997 3.125L13.8352 8.125Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1.25 8.125H18.75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
    )
}
